import './login.css';
import { LoginFormComponent } from './components/form';

export function LoginPage(){
    return LoginFormComponent();
}